exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".box-card[data-v-e8fa400e]{text-align:left;margin:0}.clearfix[data-v-e8fa400e]{text-align:left;-ms-flex-line-pack:left;align-content:left;-ms-flex-align:left;align-items:left;margin:auto}.subtitle[data-v-e8fa400e],.title[data-v-e8fa400e]{text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e8fa400e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProductIntro.vue
// module id = 154
// module chunks = 0